<template>
    <v-container fluid>
        <v-row class="mx-md-16 px-md-16" justify="center" no-gutters>
            <v-col cols="10">
                <v-row justify-lg="start" justify-md="start" justify="center" >
                    <v-col cols="8" sm="10" :md="getCols" :lg="getCols" v-for="(item, index) in pages[page - 1]" :key="index" class="mx-0 px-0"  >
                        <PostCard :feed="feed" :item="item" :minWidth="items.length >= 3 ? '0' : '400'" class="ma-0 py-2"/>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row justify="center" class="mt-15 pt-15">
            <v-col cols="12">
                <v-pagination
                    v-model="page"
                    :length="length"
                    :disabled="items.length <= pageSize"
                    circle
                ></v-pagination>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import PostCard from "@/components/PostCard";

export default {
    components: { PostCard },
    name: "PostList",
    props: ["items", "feed"],
    data() {
        return {
            page: 1,
            length: 1,
            pageSize: 6, // TODO parametrizar
            isLoading: true,
            pages: [],
        };
    },
    created() {
        this.paginate(this.items);
        this.length = this.pages.length;
    },
    computed: {
        getCols() {
            let cols = "4";
            if (this.pages[this.page - 1].length  === 1) cols = "12";
            if (this.pages[this.page - 1].length  === 2) cols = "6";

            return cols;
        }
    },
    methods: {
        paginate(items) {
            let block = 0;
            const nblock = parseInt(items.length / this.pageSize);
            const rblock = items.length % this.pageSize;
            this.pages = [];
            for (block = 0; block < nblock; block++) {
                this.pages.push(items.slice(block * this.pageSize, block * this.pageSize + this.pageSize));
            }
            if (rblock > 0) {
                this.pages.push(items.slice(block * this.pageSize, block * this.pageSize + rblock));
            }
        },
    }
};
</script>

<style scoped>
</style>

